import { STOCK_SLIP_TYPE } from '@/utils/enum'

const IMPORT_STOCK = STOCK_SLIP_TYPE.IMPORT_PROVIDER
const EXPORT_STOCK = STOCK_SLIP_TYPE.EXPORT_PROVIDER

export const STOCK_SLIP_LIST_MODE = Object.freeze({
  MANUAL: 'manual',
  AUTO: 'auto',
})

/** Nhãn hiển thị cho phiếu kho sinh từ HĐ/đơn hàng */
export const AUTO_STOCK_SLIP_LABELS = Object.freeze({
  MENU_PARENT: 'Phiếu từ đơn hàng',
  MENU_IMPORT: 'Phiếu nhập',
  MENU_EXPORT: 'Phiếu xuất',
  LIST_IMPORT: 'Danh sách phiếu nhập từ đơn hàng',
  LIST_EXPORT: 'Danh sách phiếu xuất từ đơn hàng',
  DETAIL_IMPORT: 'Chi tiết phiếu nhập từ đơn hàng',
  DETAIL_EXPORT: 'Chi tiết phiếu xuất từ đơn hàng',
})

const ALL_TYPE_OPTION = Object.freeze({ id: 0, name: 'Tất cả' })

/** Phiếu sinh từ HĐ/đơn — khớp BE AUTO_BILL_DRIVEN_STOCK_SLIP_TYPES */
export const AUTO_BILL_DRIVEN_STOCK_SLIP_TYPES = Object.freeze([
  STOCK_SLIP_TYPE.EXPORT_WARRANTY_FROM_BILL,
  STOCK_SLIP_TYPE.EXPORT_STOCK_TO_SALE,
  STOCK_SLIP_TYPE.EXPORT_STOCK_TO_SALE_WHOLSE,
  STOCK_SLIP_TYPE.EXPORT_TO_SHIPPING,
  STOCK_SLIP_TYPE.IMPORT_STOCK_FROM_BILL,
  STOCK_SLIP_TYPE.IMPORT_STOCK_FROM_ORDER,
])

export const PRODUCTION_ORDER_STOCK_SLIP_TYPES = Object.freeze([
  STOCK_SLIP_TYPE.IMPORT_FROM_CHANGE_PRODUCT,
  STOCK_SLIP_TYPE.EXPORT_FROM_CHANGE_PRODUCT,
  STOCK_SLIP_TYPE.IMPORT_FROM_CHANGE_IMEI,
  STOCK_SLIP_TYPE.EXPORT_FROM_CHANGE_IMEI,
])

export const MANUAL_IMPORT_TYPE_OPTIONS = Object.freeze([
  ALL_TYPE_OPTION,
  { id: 1, name: 'Nhập NCC' },
  { id: 2, name: 'Nhập chuyển kho' },
  { id: 5, name: 'Nhập thu cũ' },
  { id: 6, name: 'Nhập kho HTBH' },
  { id: 7, name: 'Nhập kho mượn máy' },
  { id: 8, name: 'Nhập kho bảo hành NCC' },
  { id: 38, name: 'Nhập kho từ phiếu kiểm kho' },
])

export const AUTO_IMPORT_TYPE_OPTIONS = Object.freeze([
  ALL_TYPE_OPTION,
  { id: 3, name: 'Nhập trả hàng' },
  { id: 4, name: 'Nhập chuyển hoàn' },
])

export const MANUAL_EXPORT_TYPE_OPTIONS = Object.freeze([
  ALL_TYPE_OPTION,
  { id: 1, name: 'Xuất trả NCC' },
  { id: 5, name: 'Xuất bảo hành' },
  { id: 6, name: 'Xuất bảo hành NCC' },
  { id: 37, name: 'Xuất kho kiểm kê' },
])

export const AUTO_EXPORT_TYPE_OPTIONS = Object.freeze([
  ALL_TYPE_OPTION,
  { id: 2, name: 'Xuất bán lẻ' },
  { id: 3, name: 'Xuất bán buôn' },
  { id: 4, name: 'Xuất giao hàng' },
  {
    id: STOCK_SLIP_TYPE.EXPORT_WARRANTY_FROM_BILL,
    name: 'Xuất kho bảo hành từ hóa đơn bảo hành',
  },
])

const AUTO_IMPORT_FILTER_MODES = Object.freeze([3, 4])
const AUTO_EXPORT_FILTER_MODES = Object.freeze([
  2,
  3,
  4,
  STOCK_SLIP_TYPE.EXPORT_WARRANTY_FROM_BILL,
])

const AUTO_EXPORT_TYPE_LABELS = Object.freeze({
  [STOCK_SLIP_TYPE.EXPORT_STOCK_TO_SALE]: 'Xuất bán lẻ',
  [STOCK_SLIP_TYPE.EXPORT_STOCK_TO_SALE_WHOLSE]: 'Xuất bán buôn',
  [STOCK_SLIP_TYPE.EXPORT_TO_SHIPPING]: 'Xuất giao hàng',
  [STOCK_SLIP_TYPE.EXPORT_WARRANTY_FROM_BILL]: 'Xuất kho bảo hành từ hóa đơn bảo hành',
})

const AUTO_IMPORT_TYPE_LABELS = Object.freeze({
  [STOCK_SLIP_TYPE.IMPORT_STOCK_FROM_BILL]: 'Nhập trả hàng',
  [STOCK_SLIP_TYPE.IMPORT_STOCK_FROM_ORDER]: 'Nhập chuyển hoàn',
})

export function cloneStockSlipTypeOptions(options) {
  return options.map((item) => ({ ...item }))
}

export function sanitizeStockSlipTypeMode(mode, options) {
  const parsed = Number(mode)
  if (!Number.isFinite(parsed) || parsed === 0) {
    return 0
  }
  return options.some((item) => item.id === parsed) ? parsed : 0
}

export function getImportTypeOptionsByListMode(listMode) {
  return listMode === STOCK_SLIP_LIST_MODE.AUTO
    ? cloneStockSlipTypeOptions(AUTO_IMPORT_TYPE_OPTIONS)
    : cloneStockSlipTypeOptions(MANUAL_IMPORT_TYPE_OPTIONS)
}

export function getExportTypeOptionsByListMode(listMode) {
  return listMode === STOCK_SLIP_LIST_MODE.AUTO
    ? cloneStockSlipTypeOptions(AUTO_EXPORT_TYPE_OPTIONS)
    : cloneStockSlipTypeOptions(MANUAL_EXPORT_TYPE_OPTIONS)
}

export function isAutoBillDrivenStockSlipType(type) {
  return AUTO_BILL_DRIVEN_STOCK_SLIP_TYPES.includes(Number(type))
}

/**
 * Phiếu auto chỉ xem trên form nhập/xuất kho chính.
 * XBBH (24) vẫn sửa qua warranty-stock-slips.
 */
export function isStockSlipViewOnly(itemOrType) {
  const type = typeof itemOrType === 'object' ? itemOrType?.type : itemOrType
  if (!isAutoBillDrivenStockSlipType(type)) {
    return false
  }
  return Number(type) !== STOCK_SLIP_TYPE.EXPORT_WARRANTY_FROM_BILL
}

export function isAutoStockSlipListFilter(stockDirectionType, mode) {
  const parsedMode = Number(mode)
  if (!parsedMode) {
    return false
  }
  if (Number(stockDirectionType) === IMPORT_STOCK) {
    return AUTO_IMPORT_FILTER_MODES.includes(parsedMode)
  }
  if (Number(stockDirectionType) === EXPORT_STOCK) {
    return AUTO_EXPORT_FILTER_MODES.includes(parsedMode)
  }
  return false
}

export function getStockSlipListApiPathByMode(listMode) {
  return listMode === STOCK_SLIP_LIST_MODE.AUTO ? 'v1/stock-slips/auto' : 'v1/stock-slips'
}

export function getStockSlipSummaryApiPathByMode(listMode) {
  return listMode === STOCK_SLIP_LIST_MODE.AUTO
    ? 'v1/stock-slips/auto/summary'
    : 'v1/stock-slips/summary'
}

export function getAutoStockSlipTypeBadgeLabel(stockSlip, direction = 'export') {
  if (!stockSlip) return ''
  if (stockSlip.typeName) return stockSlip.typeName

  if (stockSlip.hasVat === false) {
    return direction === 'import' ? 'Nhập kho HKD' : 'Xuất kho HKD'
  }

  const type = Number(stockSlip.type)
  const labels = direction === 'import' ? AUTO_IMPORT_TYPE_LABELS : AUTO_EXPORT_TYPE_LABELS
  if (labels[type]) return labels[type]

  return direction === 'import' ? 'Nhập kho' : 'Xuất kho'
}

export function getAutoStockSlipDetailSubtitle(stockSlipId, direction = 'export') {
  const action = direction === 'import' ? 'nhập' : 'xuất'
  return `Phiếu ${action} từ đơn hàng · ID phiếu ${stockSlipId || '—'}`
}

const AUTO_IMPORT_STOCK_SLIP_TYPES = Object.freeze([
  STOCK_SLIP_TYPE.IMPORT_STOCK_FROM_BILL,
  STOCK_SLIP_TYPE.IMPORT_STOCK_FROM_ORDER,
])

export function getAutoStockSlipModalDirection(stockSlipType) {
  const type = Number(stockSlipType)
  return AUTO_IMPORT_STOCK_SLIP_TYPES.includes(type) ? 'import' : 'export'
}

/** @deprecated Dùng getStockSlipListApiPathByMode theo trang riêng manual/auto */
export function getStockSlipListApiPath(stockDirectionType, mode) {
  return isAutoStockSlipListFilter(stockDirectionType, mode)
    ? 'v1/stock-slips/auto'
    : 'v1/stock-slips'
}

/** @deprecated Dùng getStockSlipSummaryApiPathByMode theo trang riêng manual/auto */
export function getStockSlipSummaryApiPath(stockDirectionType, mode) {
  return isAutoStockSlipListFilter(stockDirectionType, mode)
    ? 'v1/stock-slips/auto/summary'
    : 'v1/stock-slips/summary'
}
